<template>
  <div>
    <HeaderCreditor header="รายการคำสั่งซื้อติดเครดิตทั้งหมด" :img_header="header_image" link_back="creditor/reportdebtor"/>
    <Report_debtor_detail/>
  </div>
</template>

<script>
import HeaderCreditor from "@/components/admin/creditor/headercreditor/HeaderCreditor";
import HeaderImage from "@/assets/data_creditor.png";
import Report_debtor_detail from "@/components/admin/creditor/Report_debtor_detail";
export default {
  name: "ReportDebtorDetail",
  components: {
    Report_debtor_detail,
    HeaderCreditor
  },
  data() {
    return {
      header_image: HeaderImage,
    }
  }
}
</script>

<style scoped>

</style>
